export function isNumber(str: string) {
  return /^-{0,1}\d+$/.test(str);
}

export function toNumber(value: string | number | undefined): number | undefined {
  return (typeof value === 'string') ? +value : value;
}

export function moveElement<T>(list: T[], from: number, to: number): T[] {
  list = [...list];

  list.splice(to, 0, list.splice(from, 1)[0]);

  return list;
}
